import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  TableSortLabel,
  useTheme,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from '@mui/material/Pagination';

const AgentsTable = (props) => {
  const theme = useTheme();
  const order = props.order || 'desc';
  const orderBy = props.orderBy || 'id';

  // Mapeamento entre headers e campos dos dados
  // IMPORTANTE: Os nomes aqui devem corresponder aos campos do backend
  const getFieldName = (headerTitle) => {
    const headerMap = {
      'Nome': 'name',
      'Email': 'email',
      '': null, // Coluna vazia (botão delete)
    };
    return headerMap[headerTitle] || null;
  };

  // Handler para mudança de ordenação - comunica ao componente pai
  const handleRequestSort = (property) => {
    if (!props.onSortChange) return;
    
    const isAsc = orderBy === property && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    const newOrderBy = property;
    
    props.onSortChange(newOrderBy, newOrder);
  };

  return (
    <>
      <TableContainer className="table-container" component={Paper}>
        <Table
          size="small"
          aria-label="collapsible table"
          className="basic-table"
        >
          <TableHead className="basic-table-head">
            <TableRow>
              {['Nome', 'Email', ''].map((title, key) => {
                const fieldName = getFieldName(title);
                const isSortable = fieldName !== null;
                
                return (
                  <TableCell
                    key={key}
                    align="center"
                    style={{ color: '#F5F5F5' }}
                    sortDirection={orderBy === fieldName ? order : false}
                  >
                    {isSortable ? (
                      <TableSortLabel
                        active={orderBy === fieldName}
                        direction={orderBy === fieldName ? order : 'asc'}
                        onClick={() => handleRequestSort(fieldName)}
                        sx={{
                          '&.Mui-active': {
                            color: theme.palette.secondary.main,
                          },
                          '& .MuiTableSortLabel-icon': {
                            color: orderBy === fieldName 
                              ? `${theme.palette.secondary.main} !important` 
                              : 'rgba(255, 255, 255, 0.54)',
                          },
                          '&:hover': {
                            color: theme.palette.secondary.light,
                          },
                          '&:hover .MuiTableSortLabel-icon': {
                            color: `${theme.palette.secondary.light} !important`,
                          },
                          color: orderBy === fieldName 
                            ? theme.palette.secondary.main 
                            : 'inherit',
                        }}
                      >
                        {title}
                      </TableSortLabel>
                    ) : (
                      title
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {props.agents?.length > 0
              ? props.agents.map((agent) => {
                  return (
                    <TableRow className="row" key={agent.id}>
                      <TableCell
                        className=" clickable"
                        align="center"
                        onClick={() => props.showAgentForm(agent)}
                      >
                        {agent.name}
                      </TableCell>

                      <TableCell
                        className=" clickable"
                        align="center"
                        onClick={() => props.showAgentForm(agent)}
                      >
                        {agent.email}{' '}
                      </TableCell>

                      <TableCell>
                        <Tooltip title="Remover">
                          <DeleteIcon
                            className="clickable"
                            onClick={() => props.onDeleteAgent(agent.id)}
                          />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        shape="rounded"
        className="table-pagination"
        count={props.pages}
        page={props.current_page}
        onChange={(e, value) => {
          props.onPageChange(value);
        }}
      />
    </>
  );
};

export default AgentsTable;
